import React from 'react';
import Reflux from 'reflux';
import Modal from 'react-bootstrap/lib/Modal';
import ModalActions from 'flux/actions/ModalActions';
import ModalStore from 'flux/stores/ModalStore';
import classNames from 'classnames';

/**
 * Generic modal
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(ModalStore, 'modalVisibility')],

  propTypes: {
    title: React.PropTypes.node,
    footer: React.PropTypes.element,
    name: React.PropTypes.string.isRequired,
    headerClassName: React.PropTypes.string,
    modalType: React.PropTypes.string,
    onHide: React.PropTypes.func,
    overrideHide: React.PropTypes.bool, //Make modal permanently display
    closeButton: React.PropTypes.bool,
    enforceFocus: React.PropTypes.bool,
    display: React.PropTypes.bool, //Overwrite modal store state to manually display
  },

  getDefaultProps() {
    return {
      title: '',
      closeButton: true,
      enforceFocus: false,
      hasRowClass: true,
    };
  },

  displayName: 'Modal',

  render() {
    let {
      title,
      footer,
      children,
      enforceFocus,
      dialogClassName,
      hasRowClass,
    } = this.props;

    return (
      <Modal
        enforceFocus={enforceFocus}
        show={this.isVisible()}
        onHide={this._handleClose}
        className={classNames(this.props.className, {
          row: hasRowClass == true,
        })}
        dialogClassName={dialogClassName}
      >
        {this._getHeaderNode(title)}
        {this._getBodyNode(children)}
        {this._getFooterNode(footer)}
      </Modal>
    );
  },

  _getHeaderNode(title) {
    return (
      <Modal.Header
        className={this.props.headerClassName}
        closeButton={this.props.closeButton}
      >
        <Modal.Title
          className="text-center"
          key={'modal-header-' + this.props.name}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
    );
  },

  _getBodyNode(content) {
    return (
      <div key={'modal-body ' + this.props.name} className="form-show">
        <Modal.Body>{content}</Modal.Body>
      </div>
    );
  },

  _getFooterNode(footer) {
    if (!footer) return null;

    return <Modal.Footer>{footer}</Modal.Footer>;
  },

  _handleClose() {
    let { name, onHide, overrideHide } = this.props;

    if (onHide) onHide();
    if (overrideHide) return;

    ModalActions.hide(name);
  },

  isVisible() {
    const { display } = this.props;
    return display || this.state.modalVisibility.get(this.props.name)
      ? true
      : false;
  },
});
